import { closeWindow } from '../utils/close-window';
import { config as devToolsConfig } from '../utils/config';
import { DetectorType } from '../utils/enum';
import { clearDetectorDetectTimeout, registInterval } from '../utils/interval';
import { markDevToolOpenState } from '../utils/open-state';

export interface DetectorConfig {
  type: DetectorType;
  enabled?: boolean;
}

export abstract class Detector {
  type: DetectorType = DetectorType.Unknown;
  enabled: boolean = true;

  constructor({ type, enabled = true }: DetectorConfig) {
    this.type = type;
    this.enabled = enabled;
    if (this.enabled) {
      registInterval(this);
      this.init();
    }
  }

  onDevToolOpen() {
    clearDetectorDetectTimeout();
    devToolsConfig.ondevtoolopen(this.type, closeWindow);
    markDevToolOpenState(this.type);
  }

  init() {}
  abstract detect(time: number): void;
}